var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[(_vm.forecast_comment && _vm.forecast_comment.length)?[_c('p',{staticClass:"font-weight-bold mt-6 px-8",class:_vm.forecast_comment && 'mb-0'},[_vm._v(" Prognos ")]),_c('p',{staticClass:"text-body-2 px-8 text--secondary"},[_vm._v(" "+_vm._s(_vm.forecast_comment)+" ")])]:_c('div',{staticClass:"mt-6"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }